module.exports = __webpack_public_path__ + "img/icon_map_ljsf.ae9c106e.png";